export class TimeSpanHelper {
    public static buildTimespanForMomentJS(timespan: string): string {
        if (timespan[0] === '+' || timespan[0] === '-') return timespan;
        return `+${timespan}`;
    }
}
